<template>
	<template v-if="templateData">
		<ProcessMapComponent
			:templateData="templateData"
			/>
	</template>
</template>

<script>

import ProcessMapComponent from '@vueapp/components/ProcessMapComponent.vue'

export default {
	name: 'ProcessMapView',
	components: {
		ProcessMapComponent
	},
	props: {
		postSlug: {
			type: String,
			required: true,
			default: ''
		}
	},
	data() {
		return {
			templateData: null
		}
	},

	async beforeMount() {

        const params = new URLSearchParams(window.location.search),
            eParams = {}
        params.forEach((value, name) => {
            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+]+)$/) ) {
                eParams[name] = value
            }
        });

        let paramsString = ( new URLSearchParams(eParams) ) .toString()

		// console.log(BRYTER.homeUrl + '/process/' + this.postSlug + '/?env=' + BRYTER.envId + '&json')
	    fetch( BRYTER.homeUrl + '/process/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
      		.then(response => response.json())
      		.then(data => {
        		this.templateData = data
        		// this.loading = false
        		
      		})
  	},
  	created() {
		window.addEventListener('resize', this.onWindowResize)
		window.dispatchEvent(new Event('resize'))
	},
	destroyed() {
		window.removeEventListener('resize', this.onWindowResize)
	},
  	methods: {
  		onWindowResize() {
  			console.log('ProcessMapView::onWindowResize()')
            const w = window.innerWidth,
                h = window.innerHeight

            // console.log('onWindowResize', w, h)
            // if ( $('#lanes').length ) {
                const l = document.getElementById('lanes'),
                    lis = document.getElementsByClassName('.lanes--inner'),
                    ls = document.getElementById('lanes-shadow')
                Array.from(lis).forEach( (li) => {
                	const obj1 = {'width': li.innerWidth, 'height': l.innerHeight < li.innerHeight ? l.innerHeight : li.innerHeight },
	                    obj2 = { 
	                		left: l.offsetLeft,
	                		top: l.offsetTop
	                	}
	                // console.log(obj1, obj2)
	                ls.css( { ...obj1, ...obj2 })
                })
                
            // }
            // console.log($('#lanes--inner').offset())
        }
  	}
}
</script>